import React, { useEffect, useState } from 'react';
import { Group, SegmentedControl } from '@mantine/core';

interface FilterButtonProps {
    options: string[];
    onChangeFunction: (value: string) => void;
    defaultValue?: string;
}

function FilterButton({ options, onChangeFunction, defaultValue }: FilterButtonProps) {
    const initial = defaultValue || options[0] || "";
    const [value, setValue] = useState(initial);

    useEffect(() => {
        if (defaultValue && defaultValue !== value) {
            setValue(defaultValue);
        }
    }, [defaultValue, value]);

    return (
        <Group justify="center" my="md">
            <SegmentedControl
                value={value}
                onChange={(nextValue) => {
                    setValue(nextValue);
                    onChangeFunction(nextValue);
                }}
                data={options.map((option) => ({ label: option, value: option }))}
                radius="xl"
                color="brand"
            />
        </Group>
    );
}

export default FilterButton;
